import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { SettingsService } from '../shared/services/settings/settings.service';
import urlJoin from 'url-join';
import { Injectable } from '@angular/core';
import { AlertNotificationDetails } from './alert-notification-details.model';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class PayService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService,
  ) { }

  /** @deprecated */
  getAlertsPayDetails(payId: string, params: object): Observable<AlertNotificationDetails> {
    return this.http.get<AlertNotificationDetails>(this.buildUriForExport(payId, params));
  }

  /** @deprecated */
  getAlertsDetails(ids: string[]): Observable<AlertNotificationDetails[]> {
    return this.http.post<AlertNotificationDetails[]>(this.getUri('cui-payment/v1/tenants/', 'alertandnotificationdetails'),
      ids
    );
  }

  private buildUriForExport(payId: string, params: object): string {
      return this.getUri('payment/v1/tenants/', 'pays/' + payId + '/employeealertandnotificationdetails', params);
  }

  private getUri(prefix: string, path: string, params: object = null): string {
    let uri = urlJoin(this.baseUri(prefix), path);
    if (params) {
      uri += '?' + this.buildQueryParameters(params);
    }
    return uri;
  }

  private baseUri(prefix: string) {
    return urlJoin(ROUTE_TOKEN_GATEWAY_URL, prefix + `${encodeURI(this.settings.tenantId)}/`);
  }

  private buildQueryParameters(params: object): string {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function(key, index) {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams.toString();
  }
}
